<template>
  <div class="page">
    <div class="page-inner">
      <div class="card card-fluid">
        <div class="card-body p-sm-5">
          <template v-for="(item,i) in items">
            <a class="font-weight-bold" @click="detailJob(item.id)">
              <h4>{{item.title}} </h4>
            </a>
            <p><em>{{item.date}}</em> | <em>Posted By {{item.real_name}}</em></p>
            <div v-html="item.snippet"></div>
          </template>
        </div>
      </div>
      <div class="row align-items-center">
        <pagination-info :per-page="perPage" :rows="total" :current-page="currentPage"></pagination-info>
        <div class="col-sm-12 col-md-7 d-flex justify-content-end">
          <div class="dataTables_paginate paging_simple_numbers">
            <b-pagination v-model="currentPage" :per-page="perPage" v-on:click="getData"   :total-rows="total" ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import PaginationInfo from "../../PaginationInfo";
import {BPagination} from "bootstrap-vue";

export default {
  name: "CareerIndex",
  components: {PaginationInfo, BPagination},
  data(){
    return {
      currentPage:1,
      perPage:10,
      total:0,
      items:[]
    }
  },
  watch:{
    currentPage(){
      this.getData()
    }
  },
  methods:{
    getData(){
      let userProfile = JSON.parse(this.$store.getters.userProfile)
      let payload = {
        company_id:userProfile.data.attributes.company_id,
        lang:'en',
        page:this.currentPage,
        limit:this.perPage
      }
      AxiosCall.Get(payload, urlApi.news.career).then(res=>{
        if(res.success){
          for(let data of res.atributes){
            this.items.push(data)
          }
          this.total = res.total
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    detailJob(id){
      this.$router.push({name:'CareerDetail', query:{id:id}})
    }
  },
  created() {
    this.getData()
  }
}
</script>